<ng-content></ng-content>
<span
  #showMore
  class="minni-clamp-action"
  [style.background-color]="backgroundColor"
  [ngStyle]="readMoreOptions?.styles || {}"
  [ngClass]="readMoreOptions.classes || {}"
  ><span *ngIf="isContentClamped()" (click)="handleShowMoreEnable(true)"
    >...{{ readMoreOptions.readMoreText }}</span
  >
  <span *ngIf="isShowMoreEnable" (click)="handleShowMoreEnable(false)">{{
    readMoreOptions.readLessText
  }}</span></span
>
